import 'css-chunk:../authentication/frontend/pages/register-page/mobile.module.scss';export default {
  "mobile": "_mobile_bi7aq_1",
  "figure": "_figure_bi7aq_28",
  "slot": "_slot_bi7aq_59"
};